import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import style from './HeaderMenuList.module.scss';
import { addUtmParam } from '../../addUtmParam';
import { useAperzaUserContext } from '../AperzaUserContext';
// <A /> component
export function HeaderMenuListItemLink({ item, rel, target, dense, className, onClick, appendIcon, }) {
    const { serviceType } = useAperzaUserContext();
    if (item.url) {
        return (React.createElement("a", { className: clsx(style.menuLink, { [style.dense]: dense }, className), href: addUtmParam(item.url, 'header', serviceType), rel: rel, target: target, onClick: onClick },
            item.title,
            React.createElement("div", { className: style.linkIcon }, appendIcon ?? (!item.headline ? React.createElement(FontAwesomeIcon, { icon: faChevronRight }) : React.createElement(React.Fragment, null)))));
    }
    return (React.createElement("div", { "aria-hidden": "true", onClick: onClick, className: clsx(style.menuLink, { [style.dense]: dense }, className) },
        item.title,
        React.createElement("div", { className: style.linkIcon }, appendIcon ?? (!item.headline ? React.createElement(FontAwesomeIcon, { icon: faChevronRight }) : React.createElement(React.Fragment, null)))));
}
// <LI /> component
export function HeaderMenuListItem(props) {
    const { item, bordered, className, children } = props;
    return (React.createElement("li", { className: clsx(style.menuListItem, { [style.headlineItem]: item?.headline }, { [style.bordered]: bordered }, className) }, children ?? React.createElement(HeaderMenuListItemLink, { ...props })));
}
// <UL /> component
export function HeaderMenuList({ grid, bordered, children }) {
    return (React.createElement("ul", { className: clsx(style.menuUl, { [style.menuGridUl]: grid }, { [style.bordered]: bordered }) }, children));
}
